//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class VirtualFolderService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[VirtualFolder.Create]
	async create(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/asset/virtual-folder/create', params || { });
	};

	//GeneratorFlag:[VirtualFolder.Delete]
	async delete(virtualFolderId, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		const params = {
			id:virtualFolderId
		}
	
		return await _server.delete('/asset/virtual-folder/delete', {'params':params})
	};

	//GeneratorFlag:[VirtualFolder.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/asset/virtual-folder/detail', {'params':params});
	};

	//GeneratorFlag:[VirtualFolder.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/asset/virtual-folder/list', {'params':params});
	};

	//GeneratorFlag:[VirtualFolder.Update]
	async update(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/asset/virtual-folder/update', params || { });
	};

//GeneratorFlag:[NewAction]
}